import { memo } from 'react';

import ReleaseOfInformationItem from '@/components/ReleaseOfInformationItem';

import { Props } from './types';

const ReleaseOfInformationList = ({ releaseOfInformationList }: Props) => {
  return (
    <ul className="space-y-4">
      {releaseOfInformationList.map((releaseOfInformation) => {
        return (
          <li key={releaseOfInformation.id}>
            <ReleaseOfInformationItem releaseOfInformation={releaseOfInformation} />
          </li>
        );
      })}
    </ul>
  );
};

export default memo(ReleaseOfInformationList);
